import { render, staticRenderFns } from "./col-2.vue?vue&type=template&id=5d25ab90&scoped=true"
import script from "./col-2.vue?vue&type=script&lang=js"
export * from "./col-2.vue?vue&type=script&lang=js"
import style0 from "./col-2.vue?vue&type=style&index=0&id=5d25ab90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25ab90",
  null
  
)

export default component.exports